import React, { useRef, useEffect } from "react";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import Container from "react-bootstrap/Container";
import LandingSection from "../components/LandingSection";
import Footer from "../components/Footer";
import ActionButton from "../utils/ActionButton";
import "../styles/UtahVerticals.css";

import "../styles/AboutUs.css";
import "@fortawesome/fontawesome-free/css/all.min.css";

import { Link } from "react-router-dom";
import "../styles/Aerospace.css";
import ModalFunction from "./Modal";
import ScrambleText from "../utils/ScrambleText";
import { ArrowUpRight } from "lucide-react";
import ActionButton1 from "../utils/ActionButton1";

const census = "/img/census.png";
const logo = "/img/1.png";
const kpi = "/img/KPI-DASH 2.png";
const AboutUsImage = "/img/aboutus1.avif";
const sourcelogo1 = "/img/unemployment-logo.png";
const sourcelogo2 = "/img/utah-job-logo.png";
const kem = "/img/kcgbetsy/kcglogo.png";
const bodex = "/img/bodexLogo (1).png";
const uraddLogo = "/img/uradd.jpg";
const fredLogo = "/img/FRED_Logo.webp";

export default function AboutUs() {
  const [modalShow, setModalShow] = React.useState(false);
  const navbarRef = useRef(null);

  // Close the navbar on outside click
  useEffect(() => {
    function handleClickOutside(event) {
      if (navbarRef.current && !navbarRef.current.contains(event.target)) {
        const navbarCollapse =
          navbarRef.current.querySelector(".navbar-collapse");
        if (navbarCollapse) {
          navbarCollapse.classList.remove("show"); // Close the navbar
        }
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <>
      <LandingSection
        data={{
          imageName: "about.webp",
          title: "About Us",
          breadcrumbs: ["About Us"],
          visible: "",
        }}
      />

      {/* About Us Section */}
      <div className="mt-[3rem] px-4 sm:px-0 about-us-content">
        <h2
          style={{
            fontSize: "40px",
            textAlign: "center",
            marginTop: "60px",
            color: "#0b3378",
          }}
        >
          About UTahData
        </h2>
        <p
          style={{
            fontSize: "24px",
            marginTop: "30px",
            marginBottom: "60px",
            color: "#0b3378",
          }}
        >
          Empowering Utahns with accessible, visual, and reliable data. Whether
          you're researching, planning, or exploring, our platform helps you
          make sense of it all.
        </p>

        <p className="about-us-content">
          At <strong>UTahData.org</strong>, we’re proud to call Utah home. Our
          mission is to empower Utahns with access to{" "}
          <strong>
            comprehensive, interactive, and user-friendly data insights
          </strong>{" "}
          that celebrate and illuminate our state’s rich diversity and dynamic
          growth.
        </p>

        <p className="about-us-highlight">
          <strong>One-stop-shop for all data related to UTah</strong>
        </p>

        <ul className="about-us-list">
          <li>
            <strong>Wide Coverage:</strong> Our platform unifies key statistics
            and trends across sectors including Manufacturing, Aerospace &
            Defense, Agriculture, Business, Engineering, Technology, Healthcare,
            and Education.
          </li>
          <li>
            <strong>Trusted Sources:</strong> By visualizing data from reliable
            organizations like the <strong>U.S. Census Bureau</strong> and other
            reputable sources, we make it easy to explore Utah’s demographics,
            industries, and economic landscape.
          </li>
          <li>
            <strong>Interactive & User-Friendly:</strong> Complex information is
            transformed into engaging, easy-to-understand visualizations for
            everyone.
          </li>
          <li>
            <strong>For Everyone:</strong> Whether you’re a researcher,
            policymaker, business leader, educator, or simply a curious citizen,{" "}
            <strong>UTahData.org</strong> helps you uncover meaningful insights
            and make informed decisions.
          </li>
        </ul>

        <p className="about-us-content">
          Together, let’s better understand the numbers that shape our state’s
          story.
        </p>

        <div className="flex flex-col sm:flex-row justify-between my-[4rem] items-center gap-4 sm:gap-0 ">
          <Link to={"/founders-note"}>
            <ActionButton1 data="Founder's Note" />
          </Link>
          <Link to={"/supporters-and-sponsors"}>
            <ActionButton1 data="Supporters and Sponsors" />
          </Link>
          <Link to={"/utah-at-a-glance/who-uses-utahdata"}>
            <ActionButton1 data="Who Uses UtahData" />
          </Link>
          <Link to={"/faq"}>
            <ActionButton1 data="FAQs" />
          </Link>
        </div>
      </div>

      {/* Sources Section */}
      <div className="mx-auto flex flex-col items-center text-center mb-0">
        <div className=" text-lg font-medium">Sources of Data :</div>
        <div className="flex flex-wrap items-center mb-[2rem] justify-center gap-4">
          <img
            src={census}
            alt="Census Bureau"
            className="max-w-full h-auto w-[10rem] sm:w-[12rem] md:w-[14rem] lg:w-[16rem]"
          />
          <img
            src={sourcelogo2}
            alt="Utah Jobs Logo"
            className="w-[10rem] sm:w-[15rem] md:w-[18rem] lg:w-[20rem] h-auto"
          />
          <div className="flex flex-col items-center gap-2">
            <img
              src={sourcelogo1}
              alt="Bureau of Labor Statistics"
              className="w-[4rem] sm:w-[5rem] md:w-[6rem] lg:w-[7rem] h-auto"
            />
            <p className="text-sm">Bureau of Labor Statistics</p>
          </div>
          <img
            src={kem}
            alt="Kem C Gardner"
            className="max-w-full h-auto w-[10rem] sm:w-[12rem] md:w-[14rem] lg:w-[16rem]"
          />
          <div className="flex flex-col items-center gap-2">
            <img
              src={uraddLogo}
              alt="URADD"
              className="w-[4rem] sm:w-[5rem] md:w-[6rem] lg:w-[7rem] h-auto"
            />
            <p className="text-sm">URADD</p>
          </div>
          <img
            src={fredLogo}
            alt="FRED - Federal Reserve Economic Data"
            className="max-w-full h-auto w-[10rem] sm:w-[12rem] md:w-[14rem] lg:w-[16rem]"
          />
        </div>
      </div>

      {/* What's Next Section */}
      <section className="why-section ">
        <div className="mt-4 md:mt-0 flex justify-center mx-auto items-center lg:w-[30rem]">
          <div className="inline-flex items-center px-3 py-1 pencil-border rounded-lg shadow-sm bg-white">
            <span className="text-[#2b2b2b] text-xs md:text-sm whitespace-nowrap font-medium leading-none">
              Built by
            </span>
            <a
              target="_blank"
              href="https://bodex.io/products/utahdata/"
              className="flex items-center"
            >
              <img src={bodex} alt="Bodex Logo" className="h-8 mx-1" />
            </a>
            <span className="text-[#2b2b2b] text-xs md:text-sm font-medium leading-none">
              using
            </span>
            <a
              target="_blank"
              href="https://bodex.io/products/kpi-dash/"
              className="flex items-center"
            >
              <img
                src={kpi}
                alt="KPI Dashboard Logo"
                className="h-12 mx-1 rounded-full"
              />
            </a>
          </div>
        </div>

        <div className="fit-text-container">
          <h1 className="background-title">Shaping Tomorrow, Together</h1>
        </div>

        <h2 className="section-heading">What's next for Utah?</h2>
        <p className="section-description">
          Utah is moving forward with bold ideas—smart cities, clean energy, and
          inclusive growth powered by data. If you're passionate about shaping
          the future or want to collaborate, reach out to us and be part of the
          journey. Let’s build a stronger, smarter Utah together.
        </p>
        <div style={{ margin: "40px 0" }}>
          <ActionButton data="Contact Us" link="/contact-us" />
        </div>
      </section>

      {/* Footer */}
      <Footer />
    </>
  );
}
